// extracted by mini-css-extract-plugin
export default {"icon":"IconPersonsalisation_icon__Vas7y"};